/**
 * Created by Thomas Mark
 * Date: 2021-04-07
 * 
 * Portfolios ändern, löschen oder anlegen.
 * 
 * Portfolios werden auf dem Server im entsprechenden Container-Verzeichnis /versions/draft/portfolios physikalisch 
 * gespeichert. Zudem werden weitere Informationen zu den einzelnen Portfolios im Inhaltsverzeichnis 'toc.json'
 * abgelegt. Bei allen CRUD-Aktionen wird die Aktion zunächst im Verzeichnis durchgeführt.
 * Wenn das Portfolio-Verzeichnis erfolgreich verändert wurde, wird die Änderung auch im 
 * Inhaltsverzeichnis 'toc.json' gespeichert.
 * 
 * Zusätzlich zu den Datei-Informationen eines Portfolios enthält die toc.json-Datei auch weiter Portfolio-Daten:
 * - name - Titel des Portfolios (z.B.: 'Lagertechnik'), dieser entspricht auch dem Namen des Verzeichnisses.
 * - color - Hintergrundfarbe des Portfolios
 * - abbr - Abkürzung des Portfolios (z.B.: 'LG')
 * - children - Untereverzeichnisse des Portfolios
 * 
 * Wird ein neues Portfolio angelegt, dann werden auch folgende Layout-Informationen angelegt:
 * - row - Zeile im Grid-System
 * - col - Spalte im Grid-System 
 * - rowSpan - Anzehl der Zeilen die das Portfolio im Grid-System einnimmt 
 * - colSpan - Anzehl der Spalten die das Portfolio im Grid-System einnimmt 
 * 
 * Dieser Pflegedialog steht nur im ADMIN-Modus zur Verfügung und kann nur in der PWA-Version 
 * aufgerufen werden.
 * 
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { withStyles } from '@material-ui/core/styles';
import { ColorPicker } from 'material-ui-color';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import * as utils from "../../../basics/utils";
import * as dirActions from "../../../store/actions/dirActions";
import * as appActions from "../../../store/actions/appActions";
import * as portfolioActions from '../../../store/actions/portfolioActions';

const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),

        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 400
    },
});

class PortfolioModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'PortfolioModal';

        this.debug = false;

        this.initPortfolio = {
            name: '',
            color: '',
            abbr: ''
        }

        this.state = {
            newPortfolio: this.initPortfolio,
            oldPortfolio: this.initPortfolio,
            validationError: false,
            validationMessage: "",
        }
    }

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================

    validateWidget = (id, value) => {
        const { portfolioList } = this.props.portfolio;

        this.debug && console.log(`validateWidget(${id}, ${value})`);

        let newState = { validationError: false, validationMessage: '' };

        // Feld 'name' prüfen
        if (id === 'name') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
        }

        // Feld 'abbr' prüfen
        if (id === 'abbr') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
            if (value.length >= 4) {
                newState = { validationError: true, validationMessage: 'Maximal drei Zeichen!' };
            }
        }

        if (value === '') {
            newState = { validationError: true, validationMessage: 'Feld darf nicht leer sein!' };
        }

        // Prüfen, ob das Gruppen-Verzeichnis schon existiert
        const existsFilter = portfolioList.filter((f) => f.name.toLowerCase() === value.toLowerCase());
        if (existsFilter.length > 0) {
            newState = { validationError: true, validationMessage: 'Portfolio existiert bereits!' };
        }

        this.debug && console.log(newState);

        this.setState(newState);
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog } = this.props.app;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {

            if (modalDialog.type === 'create') {
                this.setState({
                    newPortfolio: this.initPortfolio,
                    oldPortfolio: this.initPortfolio,
                    validationError: false,
                    validationMessage: ""
                });
            } else {
                this.setState({
                    newPortfolio: this.props.portfolio.currentPortfolio,
                    oldPortfolio: this.props.portfolio.currentPortfolio,
                    validationError: false,
                    validationMessage: ""
                });
            }
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog } = this.props.app;
        const { newPortfolio, oldPortfolio, validationError, validationMessage } = this.state;
        const { portfolio, classes } = this.props;

        // ==========================================================================
        // 
        // CALLBACKs
        // 
        // ==========================================================================

        const onError = (error) => {
            const newState = { validationError: true, validationMessage: error.response.data.message };

            this.debug && console.log(newState);

            this.setState(newState);
        }

        const onSave = () => {
            if (modalDialog.type === 'create') {

                const onCreateSuccess = () => {
                    let createPortfolio = newPortfolio;

                    const newTile = utils.getFreeCellInGrid(portfolio.portfolioList);
                    console.log('newTile:', newTile)

                    createPortfolio['row'] = newTile.y;
                    createPortfolio['col'] = newTile.x;
                    createPortfolio['rowSpan'] = 1;
                    createPortfolio['colSpan'] = 1;
                    createPortfolio['children'] = [];
                    console.log('createPortfolio:', createPortfolio)

                    this.props.createPortfolio(createPortfolio); // portfolioActions.js
                }

                this.props.createDir(newPortfolio.name, onCreateSuccess, onError); // dirActions.js
            }

            if (modalDialog.type === 'update') {
                const onRenameSuccess = () => {
                    this.props.updatePortfolio(newPortfolio.id, newPortfolio); // portfolioActions.js
                }

                this.props.renameDir(oldPortfolio.name, newPortfolio.name, onRenameSuccess, onError); // dirActions.js
            }

            if (modalDialog.type === 'delete') {

                const onDeleteSuccess = () => {
                    this.props.deletePortfolio(newPortfolio.id); // portfolioActions.js
                }

                this.props.deleteDir(newPortfolio.name, onDeleteSuccess, onError); // dirActions.js
            }
        }

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        const onChange = (e) => {
            this.validateWidget(e.target.id, e.target.value);

            this.setState({ newPortfolio: { ...newPortfolio, [e.target.id]: e.target.value } });
        }

        const onChangeColor = (value) => {
            this.setState({ newPortfolio: { ...newPortfolio, color: value.css.backgroundColor } });
        }

        const onSubmit = (e) => {
            e.preventDefault();
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        if (modalDialog.dialog !== this.component) return null;

        let dialogTitle = '';
        if (modalDialog.type === 'create') dialogTitle = 'Portfolio erstellen';
        if (modalDialog.type === 'update') dialogTitle = 'Portfolio ändern';
        if (modalDialog.type === 'delete') dialogTitle = 'Portfolio löschen';

        const disabled = modalDialog.type === 'delete';

        return (
            <div>
                <Dialog open={true} onClose={onCancel} maxWidth={'md'} aria-labelledby="form-dialog-title" >
                    <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <form className={classes.form} noValidate onSubmit={onSubmit}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    autoFocus
                                    id="name"
                                    label="Portfolio"
                                    type="text"
                                    autoComplete="off"
                                    fullWidth
                                    disabled={disabled}
                                    value={newPortfolio.name}
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                />
                                <TextField
                                    id="abbr"
                                    label="Kürzel"
                                    type="text"
                                    autoComplete="off"
                                    fullWidth
                                    disabled={disabled}
                                    value={newPortfolio.abbr}
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                />
                                {!disabled && <ColorPicker
                                    hideTextfield={false}
                                    defaultValue={newPortfolio.color}
                                    value={newPortfolio.color}
                                    onChange={color => onChangeColor(color)} />
                                }
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default">Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary" disabled={validationError}>OK</Button>
                    </DialogActions>
                    <Typography className="w-full px-8" variant="h6" noWrap>
                        {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                    </Typography>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        dir: state.dir,
        version: state.version,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, dirActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PortfolioModal));